export class EsRequestPetitions {
    public iconClass: string;
    public colorClass: string;

    constructor(
        public caseId: string,
        public parentcaseId: string,
        public caseNumber: string,
        public status: string,
        public substatus: string,
        public category: string,
        public type: string,
        public subtype: string,
        public origin: string,
        public subject: string,
        public description: string,
        public accountId: string,
        public publiccontractId: string,
        public parentworkorderId: string,
        public startDate: string,
        public closeDate: string,
        public closureComment: string,
        public recordTypeId: string
    ) {
        const substatusFilter = ["Client"];
        if (substatusFilter.includes(this.substatus)) {
            this.status = `${this.substatus}${this.status}`;
        }
    }
}

export class ESRequestsPetitionsFactory {
    static create(requestsAndOperations: EsRequestPetitions) {
        return new EsRequestPetitions(
            requestsAndOperations.caseId,
            requestsAndOperations.parentcaseId,
            requestsAndOperations.caseNumber,
            requestsAndOperations.status,
            requestsAndOperations.substatus,
            requestsAndOperations.category,
            requestsAndOperations.type,
            requestsAndOperations.subtype,
            requestsAndOperations.origin,
            requestsAndOperations.subject,
            requestsAndOperations.description,
            requestsAndOperations.accountId,
            requestsAndOperations.publiccontractId,
            requestsAndOperations.parentworkorderId,
            requestsAndOperations.startDate,
            requestsAndOperations.closeDate,
            requestsAndOperations.closureComment,
            requestsAndOperations.recordTypeId
        );
    }
}
